import { useQuery } from '@tanstack/react-query';
import { DateRange } from 'react-day-picker';
import { format } from 'date-fns';
import { getTrackingMetricsByDay } from '@/services/trackingService';
import { useAuth } from '@/hooks/useAuth';

export function useTrackingMetricsByDay(dateRange?: DateRange) {
  const { token, isAuthenticated } = useAuth();

  const startDate = dateRange?.from ? format(dateRange.from, 'yyyy-MM-dd') : undefined;
  const endDate = dateRange?.to ? format(dateRange.to, 'yyyy-MM-dd') : undefined;

  return useQuery({
    queryKey: ['tracking-metrics-by-day', token, startDate, endDate],
    queryFn: () => getTrackingMetricsByDay(token!, startDate!, endDate!),
    enabled: !!token && isAuthenticated && !!startDate && !!endDate,
    staleTime: 5 * 60 * 1000,
  });
}
